
// Helper to extract solution type from the current route
function getSolutionType(route: any): string
{
    const path = route.path.toLowerCase();
    if (path.startsWith('/portfolio')) return 'portfolio';
    if (path.startsWith('/decision')) return 'decision';
    return 'portfolio'; // default/fallback
}

// Centralized URL builders that always use current route's type
export const dynamicUiRoutes = {

    Alternatives_AlternativeDashboardPage: (route: any, workspaceId: number, tchProjectId: number, alternativeId: string) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/alternative/dashboard/${workspaceId}/${tchProjectId}/${alternativeId}`;
    },

    Alternatives_EditFormPage: (route: any, workspaceId: number, tchProjectId: number, formId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/edit-form/${workspaceId}/${tchProjectId}/${formId}`;
    },
    Alternatives_ManageKanbanPage: (route: any, workspaceId: number, tchProjectId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/kanban-statuses/${workspaceId}/${tchProjectId}`;
    },
    Alternatives_ManageLabelsPage: (route: any, workspaceId: number, tchProjectId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/alternatives-labels/${workspaceId}/${tchProjectId}`;
    },
    Alternatives_ManageAssignmentsPage: (route: any, workspaceId: number, tchProjectId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/assignments/${workspaceId}/${tchProjectId}`;
    },
    Alternatives_ImportAlternativesPage: (route: any, workspaceId: number, tchProjectId: number, alternativesListId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/import-alternatives/${workspaceId}/${tchProjectId}/${alternativesListId}`;
    },


    Criteria_CriteriaPage: (route: any, workspaceId: number, tchProjectId: number, evalModelId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/criteria-hierarchy/${workspaceId}/${tchProjectId}/${evalModelId}`;
    },
    Criteria_WeightsPage: (route: any, workspaceId: number, tchProjectId: number, evalModelId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/criteria-surveys/${workspaceId}/${tchProjectId}/${evalModelId}`;
    },
    Criteria_MeasurementsPage: (route: any, workspaceId: number, tchProjectId: number, evalModelId: number, scoringEnabled: boolean) =>
    {
        const solutionType = getSolutionType(route);

        return scoringEnabled ?
            `/#/${solutionType}/criteria-scales/${workspaceId}/${tchProjectId}/${evalModelId}` :
            `/#/${solutionType}/measurement/${workspaceId}/${tchProjectId}/${evalModelId}`;
    },
    Criteria_WeightedScoresPage: (route: any, workspaceId: number, tchProjectId: number, evalModelId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/weighted-scores/${workspaceId}/${tchProjectId}/${evalModelId}`;
    },

    Criteria_CreateWeightedScorePage1: (route: any, workspaceId: number, tchProjectId: number, evalModelId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/create-weighted-score/${workspaceId}/${tchProjectId}/${evalModelId}`;
    },
    Criteria_CreateWeightedScorePage2: (route: any, workspaceId: number, tchProjectId: number, attributeId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/create-weighted-score/${workspaceId}/${tchProjectId}?attributeId=${attributeId}`;
    },

    Criteria_EditWeightedScorePage1: (route: any, workspaceId: number, tchProjectId: number, evalModelId: number, scoreId: string) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/edit-weighted-score/${workspaceId}/${tchProjectId}/${evalModelId}?scoreId=${scoreId}`;
    },
    Criteria_EditWeightedScorePage2: (route: any, workspaceId: number, tchProjectId: number, attributeId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/edit-weighted-score/${workspaceId}/${tchProjectId}?attributeId=${attributeId}`;
    },



    Evaluation_RankingPage: (route: any, workspaceId: number, tchProjectId: number, evalModelId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/results/${workspaceId}/${tchProjectId}/${evalModelId}`;
    },
    Evaluation_CriteriaPanelistsPage: (route: any, workspaceId: number, tchProjectId: number, evalModelId: number, surveyId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/criteria-panelists/${workspaceId}/${tchProjectId}/${evalModelId}/${surveyId}`;
    },
    Evaluation_CriteriaMeetingManagerPage: (route: any, workspaceId: number, tchProjectId: number, evalModelId: number, surveyId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/criteria-review/${workspaceId}/${tchProjectId}/${evalModelId}/${surveyId}`;
    },


    Evaluation_AssessmentsPanelsPage: (route: any, workspaceId: number, tchProjectId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/assessments/${workspaceId}/${tchProjectId}`;
    },
    Evaluation_AssessmentsPanelistsPage: (route: any, workspaceId: number, tchProjectId: number, surveyId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/assessments-panelists/${workspaceId}/${tchProjectId}/${surveyId}`;
    },
    Evaluation_AssessmentsMeetingManagerPage: (route: any, workspaceId: number, tchProjectId: number, surveyId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/assessments-review/${workspaceId}/${tchProjectId}/${surveyId}`;
    },


    Evaluation_ScoringPanelsPage: (route: any, workspaceId: number, tchProjectId: number, evalModelId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/scoring-surveys/${workspaceId}/${tchProjectId}/${evalModelId}`;
    },
    Evaluation_ScoringPanelistsPage: (route: any, workspaceId: number, tchProjectId: number, evalModelId: number, surveyId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/scoring-panelists/${workspaceId}/${tchProjectId}/${evalModelId}/${surveyId}`;
    },
    Evaluation_ScoringMeetingManagerPage: (route: any, workspaceId: number, tchProjectId: number, evalModelId: number, surveyId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/scoring-review/${workspaceId}/${tchProjectId}/${evalModelId}/${surveyId}`;
    },


    Pages_RequestPagesPage: (route: any, workspaceId: number, tchProjectId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/pages/${workspaceId}/${tchProjectId}`;
    },

    Pages_EditRequestPagePage: (route: any, workspaceId: number, tchProjectId: number, pageId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/edit-page/${workspaceId}/${tchProjectId}/${pageId}`;
    },


    ProjectUsers_PeoplePage: (route: any, workspaceId: number, tchProjectId: number) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/people/${workspaceId}/${tchProjectId}`;
    },

    Reports_ReportViewPage: (route: any, workspaceId: number, tchProjectId: number, reportId: string) =>
    {
        const solutionType = getSolutionType(route);
        return `/#/${solutionType}/reportview/pb/${workspaceId}/${tchProjectId}/${reportId}`;
    },

};
